import { Sheet } from '@origo/origo-ui';
import styles from './HelpSheet.module.css';

interface HelpSheetProps {
    open: boolean;
    onClose: () => void;
}

export function HelpSheet({ open, onClose }: Readonly<HelpSheetProps>) {
    return (
        <Sheet open={open} onClose={onClose} side="right" title="Slik fungerer veiledningssystemet">
            <div className={styles.content}>
                <section className={styles.section}>
                    <h3 className={styles.heading}>Hva er veiledningspunkter?</h3>
                    <p className={styles.text}>
                        Veiledningspunkter er informasjon du lager for innbyggerne.
                        Når en innbygger ser på eiendommen sin, får de opp alle
                        relevante veiledningspunkter — samlet på ett sted.
                    </p>
                </section>

                <section className={styles.section}>
                    <h3 className={styles.heading}>Nivåer</h3>
                    <p className={styles.text}>
                        Veiledning kan legges på ulike nivåer. Punkter på høyere
                        nivåer arves automatisk nedover:
                    </p>
                    <ol className={styles.levels}>
                        <li>
                            <strong>Kommune</strong> — gjelder alle planer i kommunen.
                            Settes av kommuneadministrasjonen.
                        </li>
                        <li>
                            <strong>Planområdet</strong> — gjelder hele denne planen
                            og alle delområdene i den.
                        </li>
                        <li>
                            <strong>Delomradetype</strong> — gjelder alle områder
                            av en bestemt type, f.eks. alle lekeplasser eller
                            alle boligområder i planen.
                        </li>
                        <li>
                            <strong>Enkelt delområde</strong> — gjelder kun dette
                            ene spesifikke området.
                        </li>
                    </ol>
                </section>

                <section className={styles.section}>
                    <h3 className={styles.heading}>Arv og overstyring</h3>
                    <p className={styles.text}>
                        Når du er inne på et delområde, vil du se veiledningspunkter
                        som er arvet fra nivåene over. Disse er markert under
                        «Arvet fra plan og kommune».
                    </p>
                    <p className={styles.text}>
                        Hvis et arvet punkt ikke stemmer for dette spesifikke
                        området, kan du klikke <strong>Overstyr</strong> for å
                        lage en lokal kopi som du kan redigere fritt. Originalen
                        forblir uendret for de andre områdene.
                    </p>
                </section>

                <section className={styles.section}>
                    <h3 className={styles.heading}>Hva ser innbyggeren?</h3>
                    <p className={styles.text}>
                        Innbyggeren ser alle veiledningspunktene som gjelder for
                        sin eiendom — sammenslått fra alle nivåer, i
                        prioritetsrekkefølge. De ser ikke skillet mellom nivåene.
                    </p>
                    <p className={styles.text}>
                        Bruk «Alle veiledningspunkter» i navigasjonen for å se
                        det samme som innbyggeren ser.
                    </p>
                </section>
            </div>
        </Sheet>
    );
}
